/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { canUseDOM } from "./canUseDOM.js";
import { findDOMNode } from "./findDOMNode.js";
import { ownerWindow } from "./ownerWindow.js";
/**
 * ---
 * category: utilities/DOM
 * ---
 *
 * Wrapper function for window.matchMedia
 *
 * see https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 * @module matchMedia
 * @param {string} query - media query string
 * @param { Node | Window | React.ReactElement | React.Component | function } el - component or DOM node
 * @returns {Object} a media query list object
 */
function matchMedia(query, el) {
  const node = findDOMNode(el) || document;
  if (canUseDOM) {
    const window = ownerWindow(node);
    return window && window.matchMedia(query);
  }
  return null;
}
export default matchMedia;
export { matchMedia };